"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _peractoUi = require("@peracto/peracto-ui");

var _peractoConfig = require("@peracto/peracto-config");

var _client = require("@peracto/client");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var RedirectsImportList = function RedirectsImportList() {
  var _useClient = (0, _client.useClient)(),
      client = _useClient.client;

  var config = (0, _peractoConfig.useConfig)();
  var formatDate = config.get('user_format_date', config.get('format_date'));
  var columns = (0, _react.useMemo)(function () {
    return [{
      Header: 'Source Type',
      accessor: 'sourceType',
      Cell: function Cell(_ref) {
        var row = _ref.row,
            value = _ref.cell.value;
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
          to: "/redirects/import/".concat(row.original.originId)
        }, value);
      }
    }, {
      Header: 'Processed',
      accessor: 'processedCount'
    }, {
      Header: 'Errors',
      accessor: 'errorCount'
    }, {
      Header: 'Total',
      accessor: 'totalCount'
    }, {
      Header: 'Created By',
      accessor: 'user.email',
      id: 'createdBy',
      Cell: function Cell(_ref2) {
        var value = _ref2.cell.value;
        return value || '-';
      }
    }, {
      Header: 'Created',
      accessor: 'createdAt',
      Cell: function Cell(_ref3) {
        var value = _ref3.cell.value;
        var date = new Date(value);
        var validDate = !!date.getDate() === true;
        return value && validDate ? /*#__PURE__*/_react["default"].createElement(_peractoUi.TimeAgo, {
          title: formatDate(date),
          date: date
        }) : '-';
      }
    }, {
      Header: '% Complete',
      id: 'percentComplete',
      Cell: function Cell(_ref4) {
        var row = _ref4.row;
        return row.original.totalCount > 0 ? "".concat(Math.round(row.original.processedCount / row.original.totalCount * 100), "%") : '-';
      }
    }];
  });

  var onFetchData = function onFetchData(options) {
    return client(_client.GET_LIST, 'imports', options);
  };

  return /*#__PURE__*/_react["default"].createElement(_peractoUi.HydraTable, {
    columns: columns,
    onFetchData: onFetchData,
    noResultsMessage: "No redirect data has been imported",
    alwaysFilter: {
      importType: 'redirect'
    },
    fixedRowCount: 10,
    nestedTable: true
  });
};

var _default = RedirectsImportList;
exports["default"] = _default;